import { createApp } from "vue";
import "./css/reset.css";
import "./css/styles.scss";
import App from "./App.vue";

createApp(App).mount("#app");
